/* COLD SCHOOL — variant selection. Real Shopify variants only; disables unavailable combos. */
(function () {
  'use strict';
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-current-price]');
    var compareEl = form.querySelector('[data-compare]');
    var atc = form.querySelector('[data-atc]');
    var atcText = form.querySelector('[data-atc-text]');
    var stickyPrice = form.querySelector('[data-sticky-price]');
    var stickyBtn = form.querySelector('[data-sticky-atc-btn]');
    var buyForm = form.querySelector('[data-buy-form]');
    var isPreorder = !!form.querySelector('.preorder-flag');

    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var selected = [];
    groups.forEach(function (g, i) {
      var active = g.querySelector('[aria-pressed="true"]') || g.querySelector('[data-option-value]');
      selected[i] = active ? active.dataset.value : null;
    });

    function money(cents) {
      return (window.CS && window.CS.money ? window.CS.money.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)) : '$' + (cents / 100).toFixed(2));
    }

    function findVariant() {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function availableFor(position, value) {
      // is there any available variant with this option value given the other current selections?
      return variants.some(function (v) {
        if (v.options[position - 1] !== value) return false;
        return selected.every(function (sel, i) {
          if (i === position - 1) return true;
          return sel == null || v.options[i] === sel;
        }) && v.available;
      });
    }

    function refreshDisabled() {
      form.querySelectorAll('[data-option-value]').forEach(function (btn) {
        var pos = parseInt(btn.dataset.optionPosition, 10);
        var ok = availableFor(pos, btn.dataset.value);
        btn.disabled = !ok;
      });
    }

    function update() {
      var v = findVariant();
      refreshDisabled();
      if (!v) {
        atc.setAttribute('aria-disabled', 'true');
        atcText.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (compareEl) { compareEl.style.display = v.compare_at_price > v.price ? '' : 'none'; if (v.compare_at_price > v.price) compareEl.textContent = money(v.compare_at_price); }
      if (stickyPrice) stickyPrice.textContent = money(v.price) + (isPreorder ? ' · Preorder' : '');
      if (v.available) {
        atc.removeAttribute('aria-disabled');
        atcText.textContent = isPreorder ? 'Preorder' : 'Add to cart';
        if (stickyBtn) { stickyBtn.removeAttribute('aria-disabled'); stickyBtn.textContent = isPreorder ? 'Preorder' : 'Add to cart'; }
      } else {
        atc.setAttribute('aria-disabled', 'true');
        atcText.textContent = 'Sold out';
        if (stickyBtn) stickyBtn.setAttribute('aria-disabled', 'true');
      }
      // swap gallery image if the variant has featured media
      if (v.featured_media && window.CS && typeof window.CS.selectMedia === 'function') {
        window.CS.selectMedia(v.featured_media.id);
      }
    }

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var g = btn.closest('[data-option-index]');
        var idx = parseInt(g.dataset.optionIndex, 10);
        g.querySelectorAll('[data-option-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        selected[idx] = btn.dataset.value;
        update();
      });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.getAttribute('aria-disabled') === 'true') return;
        if (window.CS && window.CS.addToCart) window.CS.addToCart(buyForm, atc);
      });
    }

    refreshDisabled();
  });
})();
